var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.12 0.71L19.42 18L18 19.42L15.71 17.13H2.77C2.23957 17.13 1.73086 16.9193 1.35579 16.5442C0.980714 16.1691 0.77 15.6604 0.77 15.13V3.13C0.77 2.85 0.83 2.59 0.93 2.35L0 1.42L1.42 0L2.12 0.71ZM5.37 1.13H18.77C19.3004 1.13 19.8091 1.34071 20.1842 1.71579C20.5593 2.09086 20.77 2.59957 20.77 3.13V15.13C20.77 15.53 20.65 15.9 20.45 16.21L16.37 12.13H18.77V10.13H14.37L12.37 8.13H18.77V6.13H10.37L5.37 1.13ZM8.71 10.13H7.77V12.13H9.77V11.19L8.71 10.13ZM4.71 6.13H3.77V8.13H5.77V7.19L4.71 6.13Z",
    fill: "#658A9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCard);
export default __webpack_public_path__ + "static/media/noCard.aff96befc326fb0a73862ab50a95e1c4.svg";
export { ForwardRef as ReactComponent };